import { atom, selector } from "recoil";
import { AgreementScope, BaseAgreement, EnrollingConditionSet, Maybe } from "../models/generated/graphql";

type EnvironmentDataState = {
	key: string;
	default: any;
};

type RelatedAgreementsState = {
	key: string;
	default: {
		data?: Maybe<
			Array<{
				agreement: BaseAgreement;
				conditionSet: EnrollingConditionSet;
				scope: AgreementScope;
			}>
		>;
		allMatchedAgreementVersions?: Array<BaseAgreement>;
		loading: boolean;
		error?: unknown;
	};
};

type PageLoadingState = {
	key: string;
	default: boolean;
};

type NegotiationRoundsDataState = {
	key: string;
	default: { [key: string]: any };
};

const flexibleFormResponseInitialValue: EnvironmentDataState = {
	key: "flexibleFormResponse",
	default: {},
};

const createBulkFormsValue: EnvironmentDataState = {
	key: "bulkForms",
	default: {},
};

const flexibleFormValuesInitialValue: EnvironmentDataState = {
	key: "flexibleFormValues",
	default: {},
};

const negotiationRoundValuesInitialValue: NegotiationRoundsDataState = {
	key: "negotiationRoundValues",
	default: {},
};

const relevantAgreementsInitialValue: RelatedAgreementsState = {
	key: "form-related-agreements",
	default: { loading: true },
};

const pageLoadingInitialValue: PageLoadingState = {
	key: "pageLoading",
	default: true,
};

export const flexibleFormResponseState = atom(flexibleFormResponseInitialValue);
export const flexibleFormValuesState = atom(flexibleFormValuesInitialValue);
export const negotiationRoundValuesState = atom(negotiationRoundValuesInitialValue);
export const flexibleFormRelatedAgreements = atom(relevantAgreementsInitialValue);
export const pageLoadingState = atom(pageLoadingInitialValue);
export const createBulkFormsValuesState = atom(createBulkFormsValue);

export const enrollingConditionSetsSelector = selector({
	key: "enrollingConditionSets",
	get: ({ get }) => {
		const responseData = get(flexibleFormResponseState);

		return (responseData.enrollingConditionSets as Array<EnrollingConditionSet>).filter((s) =>
			s.scopes.flatMap((scope) => scope.treatmentSets).some((ts) => ts.preparations.some((p) => p.regulates.some((r) => !r.UDI)))
		);
	},
});
